






































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import FileSelectModal from "@/components/files/modals/FileSelectModal.vue";
import { getAllDesignButtonStyles } from "@/services/styles/designButtonStylesService";
// types
import { Button } from "@/services/templates/types";
import { Guid } from "guid-typescript";
import { buttonsFields } from "@/components/templates/fields/buttonsFields";
import { MediaType } from "@/services/files/types";
import { DesignButtonStyle } from "@/services/styles/types";
// validation
import validate from "@/directives/validate";
import { addButtonValidators, removeButtonValidators } from "@/components/templates/validators";
import { FILEENDPOINT } from "@/app.config";
import { Option } from "@/services/common/types";

@Component({
    directives: {
        validate
    },
    components: {
        "file-select-modal": FileSelectModal
    }
})
export default class TemplateButtons extends Vue {
    @Prop() buttons!: Button[];
    @Prop() collapseState!: boolean;

    // local state
    styleOptions = [] as Option | any;
    types = [MediaType.Image];
    localCollapseState = true;
    localButtons = [] as Button[];
    fields = buttonsFields;
    validators = {};

    // lifecycle hooks
    created() {
        this.loadDesignButtonStyles();
    }

    mounted() {
        this.localCollapseState = this.collapseState;
    }

    // Watchers
    @Watch("buttons")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localButtons = this.buttons;
        if (this.localButtons.length > 0) {
            this.localButtons.forEach(x => {
                addButtonValidators(this.validators, x.id);
            });
        }
    }

    // methods
    loadDesignButtonStyles() {
        getAllDesignButtonStyles().then((response: any) => {
            this.styleOptions.push({ id: null, text: this.$t("template.noStyle") });
            for (let index = 0; index < response.length; index++) {
                const element = response[index];
                const item: Option = {
                    id: element.id,
                    text: element.name
                };
                this.styleOptions.push(item);
            }
        });
    }

    addEmptyButton() {
        const button = {} as Button;
        button.id = Guid.create().toString();
        addButtonValidators(this.validators, button.id);
        this.localButtons.push(button);
    }

    deleteButton(id: string) {
        const item = this.localButtons.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localButtons.splice(this.localButtons.indexOf(item), 1);
        this.$nextTick(() => {
            removeButtonValidators(this.validators, item.id);
        });
    }

    selectedButtonId = "" as string;
    chooseImage(buttonId: string) {
        this.selectedButtonId = buttonId;
        (this.$refs.fileManagerDialog as any).open();
    }

    removeImage(buttonId: string) {
        this.localButtons.forEach(x => {
            if (x.id === buttonId) {
                Vue.set(x, "imageId", "");
                Vue.set(x, "imageName", "");
            }
        });
    }

    onImageSelect(file: any) {
        (this.$refs.fileManagerDialog as any).close();
        this.localButtons.forEach(x => {
            if (x.id === this.selectedButtonId) {
                Vue.set(x, "imageId", file.fileId);
                Vue.set(x, "imageName", file.name);
            }
        });
    }

    getFileSrc(fileId: string): string {
        return `${FILEENDPOINT}${fileId}`;
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("buttonsUpdated", JSON.parse(JSON.stringify(this.localButtons)));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "TemplateButtons", state: state });
    }
}
